/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Import_Map_HintInputs */

const cs_import_map_hint = /** @type {(inputs: Import_Map_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Namapujte každý zdrojový sloupec na pole ${i?.name}. Přeskočit = ignorovat.`)
};

const en_import_map_hint = /** @type {(inputs: Import_Map_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Map each source column to a ${i?.name} field. Leave as Skip to ignore.`)
};

/**
* | output |
* | --- |
* | "Map each source column to a {name} field. Leave as Skip to ignore." |
*
* @param {Import_Map_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_map_hint = /** @type {((inputs: Import_Map_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Map_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_map_hint(inputs)
	return cs_import_map_hint(inputs)
});